import logger from './logger';

export const getCartKey = (user) => {
  // Try multiple ways to identify user to ensure consistency
  const identifier = user?.id || user?._id || user?.email || 'guest';
  const key = `batinosGardenCart:${identifier}`;
  
  // Debug logging in development
  if (process.env.NODE_ENV === 'development') {
    logger.debug('Cart key generated:', key, 'from user:', { id: user?.id, _id: user?._id, email: user?.email });
  }
  
  return key;
};

export const loadCart = (user) => {
  try {
    const key = getCartKey(user);
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const saveCart = (user, cartItems) => {
  const key = getCartKey(user);
  localStorage.setItem(key, JSON.stringify(cartItems || []));
};

export const clearCartForUser = (user) => {
  const key = getCartKey(user);
  localStorage.removeItem(key);
};

export const clearAllCarts = () => {
  const keys = Object.keys(localStorage);
  keys.forEach((k) => {
    if (k.startsWith('batinosGardenCart')) {
      localStorage.removeItem(k);
    }
  });
};
